/**
 * Invite accept page (app/invite/[token]) – theme-aware for dark mode.
 */

import { StyleSheet, Platform } from 'react-native';
import type { ThemeColors } from '../src/theme/themes';

export const getInviteAcceptStyles = (theme: ThemeColors) =>
  StyleSheet.create({
    gradient: {
      flex: 1,
      justifyContent: 'center' as const,
      alignItems: 'center' as const,
      paddingTop: Platform.OS === 'web' ? 40 : 60,
    },
    loadingGradient: {
      flex: 1,
      justifyContent: 'center' as const,
      alignItems: 'center' as const,
    },
    loadingText: {
      color: theme.gray[600],
      marginTop: 16,
      fontSize: 16,
    },
    errorGradient: {
      flex: 1,
      justifyContent: 'center' as const,
      alignItems: 'center' as const,
      padding: 20,
    },
    errorTitle: {
      fontSize: 24,
      fontWeight: 'bold' as const,
      color: theme.error,
      marginBottom: 12,
      textAlign: 'center' as const,
    },
    errorMessage: {
      color: theme.gray[600],
      textAlign: 'center' as const,
      marginBottom: 24,
      paddingHorizontal: 24,
    },
    goHomeButton: {
      backgroundColor: theme.primary,
      paddingHorizontal: 32,
      paddingVertical: 14,
      borderRadius: 12,
    },
    goHomeButtonPressed: {
      opacity: 0.8,
    },
    goHomeButtonHover: {
      opacity: 0.9,
    },
    goHomeButtonText: {
      color: theme.onPrimary,
      fontSize: 16,
      fontWeight: '600' as const,
    },
    inner: {
      flex: 1,
      justifyContent: 'center' as const,
      alignItems: 'center' as const,
      padding: 20,
    },
    card: {
      backgroundColor: theme.background.card,
      borderRadius: 24,
      padding: 32,
      width: '100%' as const,
      maxWidth: 400,
      alignItems: 'center' as const,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    iconCircle: {
      width: 80,
      height: 80,
      borderRadius: 40,
      backgroundColor: theme.primary + '20',
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      marginBottom: 24,
    },
    iconText: {
      fontSize: 36,
    },
    title: {
      fontSize: 24,
      fontWeight: 'bold' as const,
      color: theme.gray[900],
      marginBottom: 12,
      textAlign: 'center' as const,
    },
    subtitle: {
      fontSize: 16,
      color: theme.gray[700],
      marginBottom: 8,
      textAlign: 'center' as const,
    },
    subtitleBold: {
      fontWeight: '600' as const,
    },
    description: {
      fontSize: 14,
      color: theme.gray[600],
      marginBottom: 32,
      textAlign: 'center' as const,
    },
    primaryButton: {
      backgroundColor: theme.primary,
      paddingHorizontal: 48,
      paddingVertical: 16,
      borderRadius: 12,
      width: '100%' as const,
      alignItems: 'center' as const,
    },
    primaryButtonDisabled: {
      backgroundColor: theme.gray[400],
    },
    primaryButtonPressed: {
      opacity: 0.8,
    },
    primaryButtonHover: {
      opacity: 0.9,
    },
    primaryButtonText: {
      color: theme.onPrimary,
      fontSize: 16,
      fontWeight: '600' as const,
    },
    secondaryButton: {
      paddingHorizontal: 48,
      paddingVertical: 16,
      width: '100%' as const,
      alignItems: 'center' as const,
    },
    secondaryButtonPressed: {
      opacity: 0.8,
    },
    secondaryButtonHover: {
      opacity: 0.9,
    },
    secondaryButtonText: {
      color: theme.primary,
      fontSize: 14,
      fontWeight: '600' as const,
    },
    buttonSpacing: {
      marginBottom: 12,
    },
  });
